/**** EC-238-[FE]  Sub Task - EC-775 Code injection ****/
import { savedOrderDetailsCartLineStyles } from "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsCartLine";
import { css } from "styled-components";

/*** Start: Refactored dynamic CSS from CMS to code for consistent behavior across environments. */
savedOrderDetailsCartLineStyles.savedOrderLineInfoContainer = {
	css: css`
		margin: 10px 0;
	`
}

savedOrderDetailsCartLineStyles.productDescriptionAndPartNumbersContainer = {
	css: css`
		margin: 10px 0;
	`
}

savedOrderDetailsCartLineStyles.productPriceAndQuantityContainer = {
	css: css`
		margin: 10px 0;
	`
}

savedOrderDetailsCartLineStyles.productDescription = {
	productDetailLink : {
		typographyProps: {
            css: css`
                width: 100%;
				font-size: 12px !important;
				padding-right: 5px;
            `,
        },
	},
	productDetailDescription : {
		css: css`
			font-size: 12px !important;
			padding-right: 5px;
		`
	}
	
}

savedOrderDetailsCartLineStyles.quantityGridItem = {
	width: [2, 2, 2, 1, 1],
    printWidth: 7,
}

savedOrderDetailsCartLineStyles.productDescription = {
	productDetailLink : {
		typographyProps: {
            css: css`
                width: 100%;
				font-size: 12px !important;
				padding-right: 5px;
            `,
        },
	},
	productDetailDescription : {
		css: css`
			font-size: 12px !important;
			padding-right: 5px;
		`
	}
}
/*** End: Refactored dynamic CSS from CMS to code for consistent behavior across environments. */